import React, { Component } from 'react';
import { Translate } from '$common';
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
import HeatmapLayer from "react-google-maps/lib/components/visualization/HeatmapLayer";
import { convertLocation } from "$lib/normalize";
import MapSkin from '$constants/map-skin.json';

let defaultCenter = { lat: 39.4751611, lng: 36.2122872 };
const Map = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    defaultZoom={6}
    defaultCenter={props.defaultCenter}
    defaultOptions={{ styles: MapSkin, scrollwheel: false }}
  >
    <HeatmapLayer data={props.self.heatMapPoints} options={{ radius: 30, opacity: 1 }}/>
  </GoogleMap>
));

export default class HeatMap extends Component {
  get heatMapPoints() {
    const { points } = this.props;
    let realPoints = [];

    points.map((marker) => {
      const location = convertLocation(marker.location);
      if (typeof location !== "undefined") {
        realPoints.push(new google.maps.LatLng(location['lat'], location['lng']));
      }
    });
    return realPoints;
  }

  componentWillMount() {
    // window.Intercom('trackEvent', 'OPENED_HEATMAP');
  }

  render() {
    const { points } = this.props;

    if (points.length > 0) {
      if (points[0].location !== null) {
        defaultCenter = convertLocation(points[points.length-1].location);
      }
    }

    return (
      <div style={{
        position: 'absolute',
        top: '0px',
        left: '-35px',
        right: '-35px',
        bottom: '0px'
      }}>
        {
          points.length > 0 ?
            <div style={{
              position: 'absolute',
              background: '#fff',
              display: 'inline-block',
              padding: '20px',
              fontSize: '16px',
              fontWeight: '600',
              zIndex: '999',
              left: 0,
              bottom: 0,
              boxShadow: '0 0 15px rgba(0,0,0,.07)'
            }}>
              {Translate.get('total')} {Translate.get('submissions')}: {points.length}
            </div>
          : ''
        }
        <Map
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env[0].GOOGLE_KEY}&v=3.exp&libraries=drawing,visualization`}
          loadingElement={
            <div style={{ height: `100%` }} />
          }
          containerElement={
            <div style={{ height: `100%` }} />
          }
          mapElement={
            <div style={{ height: `100%` }} />
          }
          defaultCenter={defaultCenter}
          self={this}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/heat-map/heat-map.js